module.exports = __webpack_public_path__ + "static/media/charles05.8f73ea92.jpg";